import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { compose } from 'redux';

import {
  withContext,
  withQueryParams,
} from 'redpoints-front-common/components';

import {
  testPurchaseClear,
  testPurchaseFetchDomains,
  testPurchaseFetchLinkInfo,
  testPurchaseSetFiltersSelected,
} from '../../../actions/testPurchaseActions';
import {
  getTestPurchaseDomainsIsLoaded,
  getTestPurchaseFiltersFromQueryParams,
  getTestPurchaseFiltersSelected,
  getTestPurchaseValidQueryParams,
} from '../../../reducers/tasks/testPurchase';
import TestPurchaseDisplayer from './TestPurchaseDisplayer';
import TestPurchaseFilters from './TestPurchaseFilters';
import useTestPurchaseDomains from './hooks/useTestPurchaseDomains';
import useTestPurchaseSetInitialData from './hooks/useTestPurchaseSetInitialData';

const TestPurchase = ({
  context,
  filtersFromQueryParams,
  filtersSelected,
  isLoadedDomains,
  testPurchaseClear,
  testPurchaseFetchDomains,
  testPurchaseFetchLinkInfo,
  testPurchaseSetFiltersSelected,
  validQueryParams,
}) => {
  const hasSomeQueryParams = Object.keys(validQueryParams).length > 0;
  const { allDomainIds, ...realSelectedFilters } = filtersSelected;

  const hasFiltersApplied = isEqual(
    filtersFromQueryParams,
    realSelectedFilters
  );

  const { isEnableFilterByTenant } = useTestPurchaseSetInitialData({
    allDomainIds,
    context,
    filtersFromQueryParams,
    hasFiltersApplied,
    hasSomeQueryParams,
    initialSelectedFilterBy: filtersSelected.filterBy,
    isLoadedDomains,
    testPurchaseFetchDomains,
    testPurchaseFetchLinkInfo,
    testPurchaseSetFiltersSelected,
  });

  useTestPurchaseDomains({
    context,
    filtersSelected,
    hasSomeQueryParams,
    initialSelectedFilterBy: filtersSelected.filterBy,
    isEnableFilterByTenant,
    testPurchaseFetchDomains,
    validQueryParams,
  });

  useEffect(() => {
    return () => {
      testPurchaseClear();
    };
  }, [testPurchaseClear]);

  return (
    <>
      <TestPurchaseFilters
        hasFiltersApplied={hasFiltersApplied}
        isEnableFilterByTenant={isEnableFilterByTenant}
      />
      <TestPurchaseDisplayer hasFiltersApplied={hasFiltersApplied} />
    </>
  );
};

const mapStateToProps = (state, { queryParams }) => ({
  filtersFromQueryParams: getTestPurchaseFiltersFromQueryParams(
    state,
    queryParams
  ),
  filtersSelected: getTestPurchaseFiltersSelected(state),
  isLoadedDomains: getTestPurchaseDomainsIsLoaded(state),
  validQueryParams: getTestPurchaseValidQueryParams(state, queryParams),
});

export default compose(
  withContext,
  withQueryParams,
  connect(mapStateToProps, {
    testPurchaseClear,
    testPurchaseFetchDomains,
    testPurchaseFetchLinkInfo,
    testPurchaseSetFiltersSelected,
  }),
  memo
)(TestPurchase);
